<template>
    <div class="messagePush">

        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" @click="goto('PublicNumberList')">公众号管理</el-menu-item>
            <el-menu-item index="2" @click="goto('PublicMobile')">模版消息管理</el-menu-item>
            <el-menu-item index="3" @click="goto('MessagePush')">推送消息管理</el-menu-item>
        </el-menu>

        <div>
            <el-button type="primary" class="add" @click="goto('MessagePushInfo')">添加推送消息</el-button>

            <div class="search">
                <el-select v-model="optionscode" placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                </el-select>
                <el-button type="primary" @click="search()">搜索</el-button>
            </div>
        </div>

        <el-table :data="tableData" class="publicMobile-table">
            <!--<el-table-column type="selection" width="55px"></el-table-column>-->
            <!--<el-table-column label="模版编号" align="left">-->
                <!--<template slot-scope="scope">-->
                    <!--{{ (scope.$index + 1 ) + ((apiData.page - 1) * 10) }}-->
                <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column prop="msgtypename" label="消息类型" align="left" width="200"></el-table-column>
            <el-table-column prop="msgname" label="消息名称" align="center" wdith="350">
            </el-table-column>
            <!--<el-table-column prop="tmplinnerid" label="模版编号" align="center" width="300"></el-table-column>-->
            <el-table-column prop="tmplname" label="微信模板名称" align="center"></el-table-column>
            <el-table-column prop="paname" label="所属公众号" align="center" width="300"></el-table-column>
            <el-table-column label="操作" align="right" width="150px">
                <template slot-scope="scope">
                    <div class="publicMobile-position">
                        <el-button type="text" @click="del(scope.row.innerid)">删除</el-button>
                        <i class="separator">|</i>
                        <el-button type="text" @click="goto('MessagePushInfo',scope.row.innerid)">编辑</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            layout="prev, pager, next"
            :total="rowCount" align="center" @current-change="fPage()" :current-page.sync="currentPage">
        </el-pagination>


    </div>
</template>

<script>
    import {findMpaccountList, findAllMpaccount, findHostmpmessageconfigList, deleteMessageTemplate} from '@/api/accountApi'
    import Loading from 'base/loading/loading'    // 引入 loading 组件
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'MessagePush',
        data() {
            return {
                activeIndex: '3',
                options: [],
                optionscode: '',
                token: JSON.parse(sessionStorage['user']).loginToken, // token
                shopID: JSON.parse(sessionStorage['shop']).ShopID, // 店铺id
                sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
                // innerid: this.$route.query.innerid,
                // code: this.$route.query.code,
                // thdcode: this.$route.query.thdcode,
                // appid: this.$route.query.appid,
                tableData: [],  // 表单数据
                currentPage: 1,     // 初始化页数
                page: 1,            // 页数
                rowCount: 0,        // 数据条数
                apiData: {}         // api数据
            }
        },
        mounted() {
            this.datalist()
            this.selectData()   // 下拉菜单列表数据
        },
        methods: {
            goto(href,innerid) {
                this.$router.push({name: href,query:{'innerid':innerid}})
            },
            fPage() {
                let clickPage = $(".el-pagination .active").html()
                // this.apiData.page = clickPage
                // 调用模版列表
                this.datalist(clickPage)
            },
            datalist(page) {
                this.setLoading(true)
                // 模版列表
                if (page) {
                    this.page = page
                }
                this.apiData = {
                    // LoginToken: this.token,
                    // ShopID: this.shopID,
                    ClientType: 3,
                    code: this.optionscode,
                    type: 0,
                    // code: this.code,
                    page: this.page,
                    pageSize: 10
                }

                // 判断搜索的数据是否为空 为空则搜索全部 不为空则只搜索关键词数据
                if (this.optionscode === '') {
                    this.apiData.type = 0
                } else {
                    this.apiData.type = 1
                }

                findHostmpmessageconfigList({
                    data: this.apiData,
                    success:data => {
                        this.setLoading(false)
                        console.log(data)
                        this.tableData = data.data.content
                        // this.rowCount = data.data.splitPage.rowCount
                    },
                    error:data => {
                        this.setLoading(false)
                    }
                })
            },
            search() {
                // 列表搜索
                this.datalist(1)
            },
            selectData() {
                var data = {
                    // LoginToken: this.token,
                    // ShopID: this.shopID,
                    ClientType: 3
                    // page: this.page,
                    // pageSize: 10
                }

                this.setLoading(true)
                // 公众号列表
                findAllMpaccount({
                    data: data,
                    success:data => {
                        this.setLoading(false)
                        // console.log('findAllMpaccount',data)

                        data.data.unshift({name:'全部',code:''})
                        this.options = data.data
                    },
                    error:data => {
                        this.setLoading(false)
                    }
                })
            },
            del(innerid) {

                var deldata = {
                    // LoginToken: this.token,
                    // ShopID: this.shopID,
                    ClientType: 3,
                    innerid: innerid
                }
                deleteMessageTemplate({
                    data: deldata,
                    success:data => {
                        this.$message.success('删除成功')
                        this.datalist(1)
                    },
                    error:data => {
                        this.$message.success('删除失败')
                    }
                })

            },
            ...mapActions ([
                'setLoading'
            ])
        },
        filters: {},
        watch: {},
        computed: {},
        components: {Loading}
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .messagePush {
        .header {
            border-left: solid 2px #409EFF;
            h1 {
                margin-left: 8px;
                color: #303133;
                font-size: 16px;
                font-weight: bold;
            }
        }
        .add {
            margin-top: 20px;
            width:138px;
            height:36px;
        }
        span {
            font-size: 14px;
        }
        img {
            float:left;
            width: 50px;
            height: 50px;
            border-radius: 100%;
        }
        .publicMobile-table {
            width:100%;
            /*min-height: 640px;*/
            text-align:center;
            margin-top: 30px;

            .publicMobile-name {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                -webkit-box-pack: start;
                -ms-flex-pack: start;
                justify-content: flex-start;

                p {
                    padding-left: 10px;
                }
            }
            .publicMobile-position {
                .el-button {
                    min-width: auto;
                }
                i {
                    margin: 0 10px;
                    color: #409EFF;
                }
            }
        }
        .el-pagination {
            margin-top: 20px
        }
        .search {
            float: right;
            margin-top: 20px;

            .el-button {
                margin-left: 20px;
                height: 36px;
            }
            .el-input, .el-input--mini, .el-input--mini .el-input__inner, .el-input__inner {
                height: 36px;
            }
            .el-input__icon {
                line-height: 36px;
            }
        }
    }
</style>
